import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { IReviewAvailability } from "../../../models/Review";
import { IUser } from "../../../models/User";
import { ReviewService } from "../../../services/review.service";

export const useGetReviewAvailabilityQuery = (user: IUser | null) => {
  return useQuery<IReviewAvailability, Error>({
    queryKey: [QUERY_CONSTANTS.GET_REVIEW_AVAILABILITY],
    queryFn: async () => ReviewService.getReviewAvailability().then((res) => res.data),
    enabled: !!user,
  });
};
